// this file was created for example purposes

import {KHExtensionsRuntime} from "../../KHExtensionsRuntime";
import React from "react";
import {Menu} from "antd";
import axios from "axios";
import {API_URL} from "../../../../constants";
import {authHeader} from "../../../../Utilities";
import {useKHExtBlackboard} from "../../KHExtensionsContext";

function testPm() {
    // axios.post(API_URL + `/hierarchies/${1}/pmtest`, {}, {headers: authHeader()})
}

function HierarchyScriptableBulkUpdate({...props}) {
    const blackboard = useKHExtBlackboard();
    return (
        <Menu.Item {...props} onClick={() => testPm()}>
            Bulk Update From Script
        </Menu.Item>
    );
}

export function registerHierarchyScriptableBulkUpdate(runtime: KHExtensionsRuntime) {
    runtime.addRender("test", schema => (
       <HierarchyScriptableBulkUpdate/>
    ));
}

